import { Theme, createStyles, makeStyles } from '@forgeglobal/design-framework';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    menuItem: {
      padding: theme.spacing(1.5, 2),
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: theme.spacing(0.5),
      whiteSpace: 'normal',
    },
    placeholder: {
      '& label.MuiFormLabel-root': {
        color: theme.palette.text.primary,
      },
    },
  })
);
